import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { FormatMoney } from "src/shared/Utils/FormatMoney";

type ProducerInternalMetrics = {
  tempoEmpresa: string;
  mediaProducao: string;
  lucroGerado: string;
  pagamentosFeitos: string;
  producaoTotal: string;
  contratosAtivos: string;
  vidasAtivas: string;
  saldoContaCorrente: string;
  statusSaldo: string;
  acessoOnline: string;
  ultimoLogin: string;
};

const getTempoEmpresaLabel = (entrada?: string) => {
  if (!entrada) return "Sem data de entrada";

  const date = new Date(entrada);
  if (Number.isNaN(date.getTime())) return "Sem data de entrada";

  const now = new Date();
  const diffYears = now.getFullYear() - date.getFullYear();

  if (diffYears <= 0) return "menos de 1 ano";
  if (diffYears === 1) return "1 ano";
  return `${diffYears} anos`;
};

export const useProducerInternalData = () => {
  const { id } = useParams();
  const producerId = id ?? "";
  const { valuesInputsProdutor: producerForm, listProdutor } = useContextProdutor();

  const producerListItem = useMemo(
    () => listProdutor.find((item) => item.id_tenant === producerId || item.id === producerId),
    [producerId, listProdutor]
  );

  const metrics = useMemo<ProducerInternalMetrics>(() => {
    const saldo = producerListItem?.contaCorrente?.saldo ?? 0;
    const saldoAbs = Math.abs(saldo);

    return {
      tempoEmpresa: getTempoEmpresaLabel(producerForm.entrada),
      mediaProducao: "R$ 0,00",
      lucroGerado: "R$ 0,00",
      pagamentosFeitos: "0",
      producaoTotal: "R$ 0,00",
      contratosAtivos: "0",
      vidasAtivas: "0",
      saldoContaCorrente: `R$ ${saldo < 0 ? "-" : ""} ${FormatMoney(String(saldoAbs))}`,
      statusSaldo: saldo >= 0 ? "Disponivel" : "Saldo negativo",
      acessoOnline: producerListItem?.is_active_access_producer ? "Acesso Ativo" : "Acesso Inativo",
      ultimoLogin: "-",
    };
  }, [producerForm.entrada, producerListItem]);

  return {
    producerId,
    producerForm,
    producerListItem,
    metrics,
  };
};
